import { render, staticRenderFns } from "./Praise.vue?vue&type=template&id=6c8992a8&scoped=true"
import script from "./Praise.vue?vue&type=script&lang=js"
export * from "./Praise.vue?vue&type=script&lang=js"
import style0 from "./Praise.vue?vue&type=style&index=0&id=6c8992a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8992a8",
  null
  
)

export default component.exports